import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { buttonsFromSerializedInAppMessage as re } from "../in-app-message-factory.js";
import InAppMessage from "./in-app-message.js";
var FullScreenMessage = /*#__PURE__*/function (_InAppMessage) {
  _inherits(FullScreenMessage, _InAppMessage);
  var _super = _createSuper(FullScreenMessage);
  function FullScreenMessage(e, r, s, t, i, a, o, p, m, n, u, c, f, d, l, g, j, x, z, h, v, w, y, S, b, k, q, A, B, C, D) {
    var _this;
    _classCallCheck(this, FullScreenMessage);
    p = p || InAppMessage.DismissType.MANUAL, k = k || InAppMessage.Orientation.PORTRAIT, _this = _super.call(this, e, r, void 0, s, t, i, a, o, p, m, n, u, c, f, d, l, g, j, x, z, h, v, w, y, S, b = b || InAppMessage.CropType.CENTER_CROP, k, q, A, B, C, D), _this["do"] = InAppMessage.TextAlignment.CENTER;
    return _this;
  }
  _createClass(FullScreenMessage, [{
    key: "dt",
    value: function dt() {
      return _get(_getPrototypeOf(FullScreenMessage.prototype), "dt", this).call(this, FullScreenMessage.es);
    }
  }], [{
    key: "Xr",
    value: function Xr(e) {
      return new FullScreenMessage(e[InAppMessage.ss.Vr], e[InAppMessage.ss.Wr], e[InAppMessage.ss.xs], e[InAppMessage.ss.Yr], e[InAppMessage.ss.Zr], e[InAppMessage.ss.URI], e[InAppMessage.ss.ra], e[InAppMessage.ss.sa], e[InAppMessage.ss.ta], e[InAppMessage.ss.ia], e[InAppMessage.ss.ns], e[InAppMessage.ss.oa], e[InAppMessage.ss.pa], e[InAppMessage.ss.ma], e[InAppMessage.ss.na], e[InAppMessage.ss.ua], e[InAppMessage.ss.ca], e[InAppMessage.ss.fa], e[InAppMessage.ss.da], e[InAppMessage.ss.la], e[InAppMessage.ss.ga], e[InAppMessage.ss.ja], e[InAppMessage.ss.xa], re(e[InAppMessage.ss.za]), e[InAppMessage.ss.ha], e[InAppMessage.ss.va], e[InAppMessage.ss.wa], e[InAppMessage.ss.CSS], e[InAppMessage.ss.ya], e[InAppMessage.ss.LANGUAGE], e[InAppMessage.ss.ks]);
    }
  }]);
  return FullScreenMessage;
}(InAppMessage);
export { FullScreenMessage as default };
FullScreenMessage.es = InAppMessage.Ke.Or;